import React from 'react';
import { formatDate } from '../../utils/formatters';
import { TASK_STAGES } from './taskStages';
import './TasksKanban.css';

const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);
const IconClose = () => <Icon><path d="M19.0068 5L5.00684 19" /><path d="M19 19L5 5" /></Icon>;

const isOverdue = (t) => t.due_date && t.stage !== 'done' && t.due_date < new Date().toISOString().slice(0, 10);

const TasksKanban = ({ tasks, onMove, onDelete, onOpen }) => {
  const byStage = TASK_STAGES.reduce((acc, [key]) => {
    acc[key] = tasks.filter((t) => (t.stage || 'todo') === key);
    return acc;
  }, {});

  const handleDrop = (e, stage) => {
    e.preventDefault();
    const taskId = Number(e.dataTransfer.getData('text/plain'));
    if (!taskId) return;
    const task = tasks.find((t) => t.id === taskId);
    if (task && (task.stage || 'todo') !== stage) onMove(taskId, stage);
  };

  return (
    <div className="tk-board">
      {TASK_STAGES.map(([key, label]) => (
        <div
          key={key}
          className="tk-col"
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, key)}
        >
          <div className={`tk-col-header tk-${key}`}>
            <span>{label}</span>
            <span className="tk-col-count">{byStage[key].length}</span>
          </div>
          <div className="tk-col-body">
            {byStage[key].map((t) => (
              <div
                key={t.id}
                className="tk-card"
                draggable
                onDragStart={(e) => e.dataTransfer.setData('text/plain', String(t.id))}
                onClick={() => onOpen(t)}
              >
                <div className="tk-card-top">
                  <span className="tk-card-title">{t.title}</span>
                  <button
                    className="tk-card-del"
                    onClick={(e) => { e.stopPropagation(); onDelete(t); }}
                    aria-label="Удалить"
                  ><IconClose /></button>
                </div>
                {(t.guest_name || t.guest_card) && (
                  <div className="tk-card-guest">{t.guest_name || t.guest_card}</div>
                )}
                <div className="tk-card-meta">
                  {t.due_date && (
                    <span className={isOverdue(t) ? 'tk-card-due tk-card-overdue' : 'tk-card-due'}>
                      {formatDate(t.due_date)}
                    </span>
                  )}
                  <span className="tk-card-assignee">{t.assignee_name}</span>
                </div>
              </div>
            ))}
            {byStage[key].length === 0 && <div className="tk-col-empty">Пусто</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TasksKanban;
